import Color from 'color';
import sortBy from 'lodash/sortBy';
import Style from '../components/Style';

export function sortByContrast(colors, control) {
  const base = Color(control);

  const contrasts = colors.map(color => {
    return { color: color, contrast: base.contrast(Color(color)) };
  });

  const sorted = sortBy(contrasts, 'contrast');

  return sorted.map(s => s.color);
}

export function textColor(background, colors) {
  let choices;
  if (colors === undefined) {
    choices = [Style.Colors.black, Style.Colors.white];
  } else {
    choices = [...colors];
  }
  return sortByContrast(choices, background).pop();
}

export function themeColors(colors) {
  const sortedColors = imageColors(colors);
  let colorLight = Color(colors.light || sortedColors.light)
    .white(80)
    .wblack(0)
    .hex();

  const colorDark = Color(colors.dark || sortedColors.dark)
    .white(20)
    .wblack(60)
    .hex();

  const colorHighlight = Color(colors.highlight || sortedColors.highlight)
    .white(15)
    .wblack(30)
    .hex();

  return { light: colorLight, dark: colorDark, highlight: colorHighlight };
}

export function imageColors(colors) {
  let colorLight =
    colors.LightVibrant ||
    colors.Vibrant ||
    colors.DarkVibrant ||
    colors.LightMuted ||
    colors.Muted ||
    colors.DarkMuted;

  const colorDark =
    colors.DarkVibrant ||
    colors.Vibrant ||
    colors.LightVibrant ||
    colors.DarkMuted ||
    colors.Muted ||
    colors.LightMuted;

  const colorHighlight =
    colors.Vibrant ||
    colors.LightVibrant ||
    colors.DarkVibrant ||
    colors.LightMuted ||
    colors.Muted ||
    colors.DarkMuted;

  return { light: colorLight, dark: colorDark, highlight: colorHighlight };
}

// Light Color
// Light Vibrant (setting white and black points - 0 tinting + shaded towards white)
// Vibrant (setting white and black points - 0 tinting + shaded towards white)
// Dark Vibrant (lightened a ton)
// Light Muted (lightened up a lot)
// Muted (lightened)
// Dark Muted (lightened)
//
// Dark Color
// Dark Vibrant (lightened slightly)
// Dark Muted (no effect or just slightly lightened)
// Muted (no effect or just slightly lightened)
// Light Muted (darkened a bit)
// Light Vibrant (darkened a bit)
// Vibrant (darkened / muted a bit)
//
// Highlight Color
// Vibrant (no effect)
// Light Vibrant (no effect currently)
// Dark Vibrant (lighten up)
// Light Muted (no effect? Or just slightly pushed towards white)
// Muted (lightened up)
// Dark Muted (lightened up)



// WEBPACK FOOTER //
// ./src/lib/Color.js